import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FusionBlender"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M15 9H12.75V3H15V1.5H9V3H11.25V9H9C8.17157 9 7.5 9.67157 7.5 10.5V13.5C7.5 14.3284 8.17157 15 9 15H11.25V21H9V22.5H15V21H12.75V15H15C15.8284 15 16.5 14.3284 16.5 13.5V10.5C16.5 9.67157 15.8284 9 15 9ZM9 13.5V10.5H15V13.5H9Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FusionBlender.vue"]]);
